import { useState, useEffect } from "react";
import axios from "axios";
import hadAd from "../Assets/images/had.png";
import hadAd2 from "../Assets/images/had2.png";
import { getMediaBaseUrl } from "../utils/backendUrl";

const TopAdBanner = () => {
  const [topAds, setTopAds] = useState([hadAd, hadAd2]); // Fallback static ads
  const [topAdIndex, setTopAdIndex] = useState(0);

  const baseUrl = getMediaBaseUrl();

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}message`);
        const items = Array.isArray(res?.data) ? res.data : [];

        // Only horizontal type + active ads from backend
        const horizontalAds = items
          .filter((ad) => ad.type === "horizontal" && ad.is_active)
          .map((ad) =>
            ad.image
              ? `${baseUrl}/uploads/messages/${ad.image}`
              : hadAd
          );

        if (horizontalAds.length > 0) {
          setTopAds(horizontalAds);
        }
      } catch (err) {
        console.error("Failed to fetch horizontal ads", err);
      }
    };

    fetchAds();
  }, []);

  useEffect(() => {
    if (topAds.length <= 1) return;
    const intervalId = setInterval(() => {
      setTopAdIndex((prev) => (prev + 1) % topAds.length);
    }, 5000);
    return () => clearInterval(intervalId);
  }, [topAds.length]);

  return (
    <div className="w-full bg-gray-50 py-2 md:py-4 shadow-sm mb-0">
      <div className="max-w-[1400px] mx-auto px-2 md:px-4">
        <div className="w-full bg-white rounded-lg overflow-hidden h-[120px] md:h-[180px] shadow-md border border-gray-200 relative group cursor-pointer">
          {topAds.map((ad, i) => (
            <img 
              key={i}
              src={ad} 
              alt={`Advertisement ${i + 1}`} 
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${i === topAdIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'}`}
            />
          ))}
          
          {/* Dots Indicator */}
          <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2 z-20">
            {topAds.map((_, i) => (
              <button 
                key={i} 
                onClick={() => setTopAdIndex(i)}
                className={`w-2.5 h-2.5 rounded-full shadow-md transition-all ${i === topAdIndex ? 'bg-purple-700 scale-125' : 'bg-white/70 hover:bg-white'}`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopAdBanner;